export const ROLES = {
  USER: 1,
  LEAGUE_ADMIN: 2,
  APP_ADMIN: 3
};